export function formatCurrency(value: string | number): string {
  if (!value) {
    return null;
  }

  value = value
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    .replace(/^0{2,}/, '0')
    .replace(/^0([1-9])/, '$1');
  return value;
}

export function getLtvPercentageValue(propertyValue: number, loanAmount: number): number {
  if (loanAmount && propertyValue) {
    const value: number = (loanAmount / propertyValue) * 100;
    return Math.min(Math.ceil(+value), 100);
  }
}

export function getLtvPercentageText(propertyValue: number, loanAmount: number, addPercentageSign = true): string {
  const percentage: number = getLtvPercentageValue(propertyValue, loanAmount);
  return percentage > 0 ? `${Math.min(percentage, 100)}${addPercentageSign ? '%' : ''}` : '';
}

// Checks if the given term length is longer than the minimum allowed term length
export function isMortgageTermValidMin(years: number, months: number) {
  return years + months / 12 >= 5;
}

// Checks if the given term length is within the maximum allowed term length
export function isMortgageTermValidMax(years: number, months: number) {
  return years + months / 12 <= 40;
}

export function isMortgageTermValid(years: number, months: number) {
  return isMortgageTermValidMin(years, months) && isMortgageTermValidMax(years, months);
}

export function toSentenceCase(text: string, convertToLowerCase: boolean = true): string {
  let result = text !== 'HomeMover' ? text.replace(/([A-Z])/g, ' $1').trim() : 'Homemover';
  if (convertToLowerCase) {
    result = result.toLowerCase();
  }
  return result.charAt(0).toUpperCase() + result.substring(1);
}
